import React from 'react';
import LocationsList from '../components/LocationsList';
import useFetchAccountsApi from '../hooks/useFetchAccountApi';

const Widget = () => {
	useFetchAccountsApi(); // fetchADD

	return <LocationsList />;
};

export default Widget;
